export default {
    Menu: 'Menu',
    Add: 'Add',
    Modify: 'Modify',
    Delete: 'Delete',
    Color: 'Color',
    Materials: 'Materials',
    Mesh: 'Mesh',
    Size: 'Size',
    Details: 'Details',
    Quantity: 'Quantity',
    AddToCart: 'Add to cart',
    Cart: 'Cart',
    Total: 'Total',
    Subtotal: 'Subtotal',
    Shipping: 'Shipping',
    LeaveConfirm: 'Are you sure you want to lose your changes?',
    Products: 'Products',
    Customization: 'Customization',
    ChooseCategory: 'Choose a category',
    SelectProduct: 'Select a product',
    Loading: 'Loading',
    ValidationInProgress: 'Validating your creation',
    ValidationLoadingMessage:
        'We are validating your creation and adding it to your cart. This will take less than a minute. Thank you for your patience.',
    LoadingScene: 'Loading scene',
    LoadingProduct: 'Loading product',
    Category: 'Category',
    Product: 'Product',
    Summary: 'Summary',
    SelectZone: 'Select a zone',
    Undo: 'Undo',
    Redo: 'Redo',
    Save: 'Save',
    Saving: 'Saving',
    Grid: 'Grid',
    SwitchTo3D: 'Switch to 3D',
    ShowZoneBorders: 'Show zone borders',
    ShowZoneBorderSingular: 'Show zone border',
    ShowZoneBordersHelp: 'Display the dashed border and label of zones on the 2D canvas.',
    ManageElements: 'Manage elements',
    StartWithTheme: 'Start with a theme',
    Customize: 'Customize',
    FromThemeLibrary: 'From our theme library',
    StartFromScratch: 'Start from scratch',
    Or: 'Or',
    PreviousCreations: 'Previous creations',
    WithModel: 'With a model',
    Search: 'Search',
    SubCategory: 'Sub-Category',
    Next: 'Next',
    Previous: 'Previous',
    Validate: 'Validate',
    EditThemeColors: 'Edit elements colors',
    AddPattern: 'Add pattern',
    EditGraduation: 'Edit graduation',
    Pattern: 'Pattern',
    Graduation: 'Graduation',
    Graduation_s: 'Graduation(s)',
    ErrorOccurred: 'An error has occurred.',
    ReloadPage: 'Please reload your page.',
    LoadingCategories: 'Loading categories',
    LoadingThemes: 'Loading themes',
    LoadingPatterns: 'Loading patterns',
    EditableThemeColors: 'Editable elements colors',
    PickAColor: 'Pick a color',
    SelectALayout: 'Select a layout',
    CreateLayer: 'Create layer',
    LastDownloads: 'Last downloads',
    Cancel: 'Cancel',
    Back: 'Back',
    BackToProvider: 'Back to {provider}',
    LayerNotFound: 'Layer not found',
    ChangeImage: 'Change image',
    ChangePattern: 'Change pattern',
    Resize: 'Resize',
    AddFilter: 'Add filter',
    PhotoCredit: 'Photo by {author} on {provider}',
    PhotoBy: 'Photo by',
    On: 'on',
    LinkRedirectionWarning: 'This link is taking you to this following website',
    LoadMore: 'Load more',
    EditLayer: 'Edit layer',
    Import: 'Import',
    FromYourDevice: 'From your device',
    FromImageGallery: 'From image gallery',
    NoGraduationsAvailable: 'No graduations available',
    Confirm: 'Confirm',
    CustomizeProduct: 'Customize your product',
    WriteYourText: 'Write your text here',
    Text: 'Text',
    Image: 'Image',
    DesignSummary: 'Summary of your design',
    AddOptions: 'Add options',
    TermsOfSale: 'General terms of sale',
    TOSMessage:
        'I certify that my design is compliant with [General terms of sale](#) and in particular the article 8- Intellectual property',
    IValidateMyCreation: 'I validate my creation',
    FunctionalityNotAvailable: 'Functionality not available',
    Lock: 'Lock',
    Unlock: 'Unlock',
    AddLayer: 'Add an element',
    PleaseAgreeTOS: 'Please agree to the terms and conditions to validate your creation.',
    ErrorExportPrintFile: 'An error occurred while exporting the print file.',
    ErrorExportProofFile: 'An error occurred while exporting the proof file.',
    ErrorAddToCart: 'An error occurred while adding to cart: ',
    Gabarit: 'Template',
    FicheTechnique: 'Technical sheet',
    GeneratingPrintFile: 'Generating print file...',
    GeneratingProofFile: 'Generating proof document...',
    LeaveCustomizer: 'Leave customizer',
    LeaveManager: 'Leave Elements Manager',
    Duplicate: 'Duplicate',
    LoadingTheme: 'Loading theme',
    LoadingPattern: 'Loading pattern',
    Expand: 'Expand',
    Shrink: 'Shrink',
    TiltLeft: 'Tilt left',
    TiltRight: 'Tilt right',
    Move: 'Move',
    NoCustomization: 'There is no design on the product.',
    MissingCustomization: 'Missing customization',
    SelectGraduation: 'Select a graduation',
    ProofTitle: 'Proof document',
    ProofDesignTitle: '2D Design',
    ProofScreenshotsTitle: '3D Renders',
    Warning: 'Warning',
    SelectZoneBeforeTheme: 'Please select a zone before choosing a theme.',
    ThemeTooManyElements: 'Theme contains too many elements. Please choose another',
    Error: 'Error',
    ProductNotFound: 'Product not found',
    ProductNotFoundMessage: 'Product not found, you will be redirected to the home page.',
    NoCategoryAvailable: 'No category available',
    CategoryNotFound: 'Category not found',
    CategoryNotFoundMessage: 'Category not found, you will be redirected to the home page.',
    Unavailable: 'Unavailable',
    // Saved Configurations
    SavedConfigurations: 'Saved Configurations',
    YourSavedConfigurations: 'Your Saved Configurations',
    NoSavedConfigurations: 'No saved configurations for this product',
    ConfigurationName: 'Configuration name',
    Created: 'Created',
    Expires: 'Expires',
    Load: 'Load',
    ConfirmDeleteConfiguration: 'Are you sure you want to delete this configuration?',
    Preview: 'Preview',
    Close: 'Close',
    '': ''
};
